<template>
    <div id="ecommerce-checkout-demo">
      <form-wizard ref="checkoutWizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" :hide-buttons="true">
        <!-- tab 1 content -->
        <tab-content title="Produtos" icon="feather icon-shopping-bag" class="mb-5">

          <!-- IF CART HAVE ITEMS -->
          <div class="vx-row" v-if="cartItems.length">

            <!-- LEFT COL -->
            <div class="vx-col lg:w-2/3 w-full relative">
              <div class="items-list-view" v-for="(item, index) in cartItems">
                <item-list-view-checkout :item="item" :maxQuantity="parseInt(stockQuantity(item, index))" :index="index" class="mb-base">

                  <!-- SLOT: ITEM META -->
                  <template slot="item-meta">
                    <h6 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary mb-2" @click="navigateLotView(item)">{{ item.name }}</h6>
                    <p class="text-success text-sm mb-2">{{ stockInfo(item, index) }}</p>
                    <p class="text-sm font-semibold mb-2">{{ item.createCompanyName.toUpperCase() }}</p>
                    <p class="text-sm mb-2"><span>Pedido No:</span> {{ item.orderId }}</p>
                    <p class="text-sm mb-2"><span>NF No:</span> {{ item.nfId ? item.nfId : 'N/A' }}</p>

                    <div class="inline-flex">
                      <div class="block mr-5">
                        <p class="mt-4 font-bold text-sm">Quantidade ({{ item.unit }})</p>
                        <vs-input-number :step="0.1" min="0" :max="stockQuantity(item, index)" :value="item.LotsProduct.quantity" @input="(value) => { changeQuantity(value, item) }" class="inline-flex"/>
                      </div>
                      <div class="block ml-5">
                        <p class="mt-4 font-bold text-sm">Preço</p>
                        <vs-input-number :step="0.1" min="0" :value="item.LotsProduct.price" @input="(value) => { changePrice(value, item) }" class="inline-flex"/>
                      </div>
                    </div>

                    <p class="font-medium text-grey mt-4">{{ getDuoDate(item) }}</p>
                    <p class="text-success font-medium">{{ recyclePercent(item) }}</p>
                  </template>

                  <!-- SLOT: ACTION BUTTONS -->
                  <template slot="action-buttons">
                    <feather-icon v-if="item.returnItem" icon="RefreshCwIcon" class="mb-5" svgClasses="h-6 w-6"/>
                    <!-- PRIMARY BUTTON: REMOVE -->
                    <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="removeItemFromCart(item)">
                      <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                      <span class="text-sm font-semibold ml-2">REMOVER</span>
                    </div>
                  </template>
                </item-list-view-checkout>
              </div>
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/3 w-full">
              <vx-card>
                <p class="font-semibold mb-3">Detalhes de quantidade</p>
                <div v-for="product in cartItems" class="flex justify-between mb-2" >
                  <span class="text-grey">{{ product.name }}</span>
                  <span>{{ (product.LotsProduct.quantity).toFixed(2) }}</span>
                </div>

                <vs-divider />

                <div class="flex justify-between font-semibold mb-3">
                  <span>Total</span>
                  <span>{{ totalQuantity }}</span>
                </div>

                <vs-divider/>
                <vs-divider/>

                <p class="font-semibold mb-3">Detalhes de preço</p>
                <div v-for="product in cartItems" class="flex justify-between mb-2" >
                  <span class="text-grey">{{ product.name }}</span>
                  <span>R$ {{ (product.LotsProduct.price *  product.LotsProduct.quantity).toFixed(2) }}</span>
                </div>

                <vs-divider/>

                <div class="flex justify-between font-semibold mb-3">
                  <span>Total</span>
                  <span>R$ {{ totalPrice }}</span>
                </div>

                <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">FECHAR PEDIDO</vs-button>
              </vx-card>
            </div>
          </div>

          <!-- IF NO ITEMS IN CART -->
          <vx-card title="Você não tem nenhum item na sua sacola" v-else>
            <vs-button @click="$router.push('/apps/products/shelfs').catch(() => {})">Procure na prateleira</vs-button>
          </vx-card>

        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Pedido" icon="feather icon-align-justify" class="mb-5">
          <div class="vx-row">

            <!-- LEFT COL: NEW ADDRESS -->
            <div class="vx-col lg:w-2/3 w-full">
              <vx-card title="Detalhes do pedido" subtitle="Informe os detalhes do pedido" class="mb-base">
                <form data-vv-scope="add-new-address">
                  <div class="vx-row">
                    <div class="vx-col sm:w-1/1 w-full">
                      <vs-input v-validate="'required'" name="orderId" label="Pedido No.:" v-model="orderId" class="w-full mt-5"/>
                      <span v-show="errors.has('orderId')" class="text-danger">{{ errors.first('orderId') }}</span>
                    </div>
                  </div>

                  <div class="vx-row">
                    <div class="vx-col sm:w-1/1 w-full">
                      <vs-input name="nfId" label="Nota Fiscal No.:" v-model="nfId" class="w-full mt-5"/>
                    </div>
                  </div>
                  <vs-button class="mt-6 ml-auto flex" @click.prevent="createLot" :disabled="invalidForm">CRIAR PEDIDO</vs-button>
                </form>
              </vx-card>
            </div>

            <div class="vx-col lg:w-1/3 w-full">

              <vx-card title="Cliente">
                <div>
                  <p class="font-semibold text-grey mb-3">Selecione o cliente</p>
                  <v-select :clearable="false" v-model="selectedCustomer" :options="customerOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
                </div>
                <div v-if="selectedCustomer" class="flex items-center">
                  <vs-avatar :src="selectedCustomerInfo.pictureUrl" class="flex-shrink-0 mr-2" size="30px"/>
                  <p>{{ selectedCustomerInfo.name }}</p>
                </div>

                <div v-if="selectedCustomerInfo.cep">
                  <vs-divider/>
                  <div>
                    <p>{{ streetInfo(selectedCustomerInfo) }}</p>
                    <p>{{ selectedCustomerInfo.complement ? selectedCustomerInfo.complement : 'N/A' }}</p>
                    <p>{{ selectedCustomerInfo.cep }}, {{ selectedCustomerInfo.neighborhood ? selectedCustomerInfo.neighborhood : 'N/A' }}, {{ selectedCustomerInfo.locationName ? selectedCustomerInfo.locationName : 'N/A' }}</p>
                  </div>
                </div>
              </vx-card>

              <vx-card title="Responsável pela separação">
                <div>
                  <p class="font-semibold text-grey mb-3">Selecione quem vai separar o pedido</p>
                  <v-select :clearable="false" v-model="selectedUser" :options="usersOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
                </div>
                <div v-if="selectedUser" class="flex items-center">
                  <vs-avatar :src="selectedUserInfo.Profile.pictureUrl" class="flex-shrink-0 mr-2" size="30px"/>
                  <div class="flex">
                    <p class="font-medium">{{ `${selectedUserInfo.Profile.name.split(' ')[0]} (` }}</p>
                    <p class="font-medium">{{ `${selectedUserInfo.rate.toFixed(2)} ` }}</p>
                    <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="cursor-pointer"></feather-icon>
                    <p class="font-medium">)</p>
                  </div>
                </div>
              </vx-card>

            </div>

          </div>
        </tab-content>
      </form-wizard>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
const ItemListViewCheckout = () => import('./components/ItemListViewCheckout.vue')

export default {
  components: { ItemListViewCheckout, FormWizard, TabContent, vSelect },
  data () {
    return {
      quantity: [],
      users: [],
      checkout: [],
      movements: [],
      connections: [],
      selectedUser: null,
      selectedCustomer: null,
      groupedMovements: [],
      // TAB 2
      nfId: '',
      orderId: ''
    }
  },
  computed: {
    invalidForm () { return !(this.orderId && this.selectedCustomer && this.selectedUser) },
    totalQuantity () {
      if (this.checkout.length === 0) return 0
      let total = 0
      for (let i = 0; i < this.checkout.length; i++) {
        total = total + this.checkout[i].LotsProduct.quantity
      }
      return total.toFixed(2)
    },
    totalPrice () {
      if (this.checkout.length === 0) return 0
      let total = 0
      for (let i = 0; i < this.checkout.length; i++) {
        total = total + (this.checkout[i].LotsProduct.quantity * this.checkout[i].LotsProduct.price)
      }
      return total.toFixed(2)
    },
    cartItems () { return this.checkout },
    customerOptions () { return this.connections.map(e => { return { id: e.id, label: e.name } }) },
    selectedCustomerInfo () { return this.connections.find(e => e.id === this.selectedCustomer.id) },
    selectedUserInfo () { return this.profileUsers.find(e => e.id === this.selectedUser.id) },
    usersOptions () { return this.profileUsers.map(e => { return { id: e.id, label: e.Profile.name } }) },
    profileUsers () { return this.users.filter(e => e.Profile !== null) },
    userHeaders () { return { headers: { Authorization: localStorage.getItem('accessToken') } } }
  },
  methods: {
    changePrice (value, item) {
      value = parseFloat(value)
      item.LotsProduct.price = parseFloat(value.toFixed(2))
    },
    changeQuantity (value, item) {
      value = parseFloat(value)
      item.LotsProduct.quantity = parseFloat(value.toFixed(2))
    },
    stockInfo (item, index) { return `${this.stockQuantity(item, index)} ${item.unit} restante do lote` },
    stockQuantity (item, index) {
      const mov = this.groupedMovements.find(e => e.ProductId === item.id)
      if (this.quantity[index]) return this.quantity[index].toFixed(2)
      return (mov) ? mov.quantity.toFixed(2) : 0
    },
    recyclePercent (item) {
      if (item.compositionValue) return `${item.compositionValue}% de material reciclável`
    },
    getDuoDate (data) {
      if (!data.validDays) return 'Sem validade definida'
      const duoDate = new Date(new Date(data.LotsProduct.createdAt).getTime() + ((data.validDays) * 24 * 60 * 60 * 1000))
      return `Válido até ${duoDate.toLocaleDateString()}`
    },
    removeItemFromCart (item) {
      const data = JSON.parse(localStorage.getItem('checkout'))
      if (!data) {
        return
      } else {
        const mapedItemsId = data.map(e => e.id)
        const index = mapedItemsId.indexOf(item.id)
        this.checkout.splice(index, 1)
      }
      localStorage.setItem('checkout', JSON.stringify(this.checkout))
    },
    // TAB 2
    streetInfo (customerInfo) { return `${customerInfo.street}, ${customerInfo.number}` },
    groupMovements () {
      this.movements = this.movements
      const groupedProductId = []
      for (let i = 0; i < this.movements.length; i++) {
        if (!groupedProductId.includes(this.movements[i].ProductId)) {
          groupedProductId.push(this.movements[i].ProductId)
        }
      }
      for (let j = 0; j < groupedProductId.length; j++) {
        const filteredMovements = this.movements.filter(e => e.ProductId === groupedProductId[j])
        let quantitySum = 0
        let priceSum = 0
        for (let k = 0; k < filteredMovements.length; k++) {
          quantitySum = filteredMovements[k].cause === 'Saída' ? quantitySum - filteredMovements[k].quantity : quantitySum + filteredMovements[k].quantity
          priceSum = filteredMovements[k].cause === 'Saída' ? priceSum - (filteredMovements[k].quantity * filteredMovements[k].price) : priceSum + (filteredMovements[k].quantity * filteredMovements[k].price)
        }
        this.groupedMovements.push({
          Product: filteredMovements[0].Product,
          ProductId: filteredMovements[0].ProductId,
          quantity: quantitySum,
          price: priceSum
        })
      }
    },
    async getUsers () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get('/api/v1/admin/company/users', this.userHeaders)
        this.users = data
        this.selectedUser = this.usersOptions[0]
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    },
    async getCustomers () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get('/api/v1/admin/company/connections', this.userHeaders)
        this.connections = data
        this.selectedCustomer = this.customerOptions[0]
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    },
    async getStock () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get('/api/v1/admin/company/movements', this.userHeaders)
        this.movements = data
        await this.groupMovements()
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    },
    async createLot () {
      try {
        this.$vs.loading()
        const lotIdGenerated = Math.floor(10000000 + (Math.random() * 90000000))
        const selectedProducts = this.cartItems.map(e => e.LotsProduct)
        await this.$http.post(
          '/api/v1/admin/company/lots',
          {
            lotId: lotIdGenerated,
            rootId: lotIdGenerated,
            nfId: this.nfId,
            orderId: this.orderId,
            userId: this.selectedUser.id,
            volumeSize: null,
            volumeTotal: null,
            weight: null,
            logisticType: 'Coleta',
            deviceTimestamp: new Date(Date.now()),
            deliveryCompanyId: this.selectedCustomer.id,
            custodyChangeCounter: 0,
            lotPictureUrl: null,
            nfePictureUrl: null,
            itemList: null,
            location: null,
            estimatedDeliveryDate: null,
            products: selectedProducts
          },
          this.userHeaders
        )
        this.$vs.notify({
          title: 'Expedição criada',
          text: 'Lote criado com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
        localStorage.setItem('checkout', JSON.stringify([]))
        this.checkout = []
        this.$refs.checkoutWizard.prevTab()
      } catch (e) {
        this.$vs.notify({
          title: 'Erro na expedição',
          text: 'Impossível criar lote',
          iconPack: 'feather',
          color: 'danger'
        })
      } finally { this.$vs.loading.close() }
    },
    navigateLotView (item) {
      this.$router.push({ name: 'app-lot-view', params: { userId: item.LotsProduct.LotId } }).catch(() => {})
    }
  },
  mounted () {
    this.getStock()
    this.getUsers()
    this.getCustomers()
    const p = JSON.parse(localStorage.getItem('checkout'))
    if (p) this.checkout = p
    this.quantity = this.process.map(e => e.LotsProduct).map(e => e.quantity)
  }
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container{
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
